import { faFlag } from '@fortawesome/free-solid-svg-icons';
import type { JSX } from 'react';
import { memo, useMemo } from 'react';

import JSONRender from '@/components/JSONRender/JSONRender';
import TimelineIcon from '@/pages/Timeline/components/TimelineIcon/TimelineIcon';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import Accordion from '@/ui/components/Accordion/Accordion';
import Card from '@/ui/components/Card';
import Heading from '@/ui/components/Heading/Heading';
import snakeCaseToTitleCase from '@/utils/snakeToTitleCase';

const DefaultTimelineSubcomponent = ({ activityLog }: TimelineSubcomponentProps): JSX.Element => {
  const { action, actor, data, timestamp } = activityLog;

  const iconAndTitle = useMemo(() => {
    return (
      <div className="flex items-center mb-1">
        <TimelineIcon icon={faFlag} />

        {action && <Heading text={snakeCaseToTitleCase(action)} value={3} />}
      </div>
    );
  }, [action]);

  const content = useMemo(() => {
    if (data && Object.keys(data).length) {
      return (
        <div className="mb-2">
          <Accordion buttonText={iconAndTitle}>
            <JSONRender jsonObject={data} />
          </Accordion>
        </div>
      );
    }

    return <Card>{iconAndTitle}</Card>;
  }, [data, iconAndTitle]);

  return (
    <div>
      {content}

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default memo(DefaultTimelineSubcomponent);
